<template>
  <v-snackbar v-model="_snackbar" :timeout="timeout" :color="color" bottom multi-line right offset-y style="margin-top: 70px">
    {{ text }}
    <v-btn color="orange" text @click="notification({ status: false, text: '', color: '' })">Close</v-btn>
  </v-snackbar>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  //
  data() {
    return {
      timeout: 2000
    };
  },
  computed: {
    ...mapState(["snackbar", "text", "color"]),
    _snackbar: {
      get() {
        return this.snackbar
      },
      set(val){
        this.showSnackbar(val)
      }
    }
  },
  methods: {
    ...mapMutations(["notification", "showSnackbar"]),
    closeNotification(){
        setTimeout(() => {
            this.notification({ status: false, text: '', color: '' })
        }, 3000);
    }
  }
};
</script>